export default {
  RouteStationsFormFields__ARRIVE_LABEL: "Arrive",
  RouteStationsFormFields__DEPART_LABEL: "Depart",
  RouteStationsFormFields__ERROR_MATCHING: "Departure and arrival airports must be different.",
  RouteStationsFormFields__ERROR_REQUIRED_ARRIVE: "Enter an arrival airport.",
  RouteStationsFormFields__ERROR_REQUIRED_DEPART: "Enter a departure airport.",
  RouteStationsFormFields__ERROR_VALID_ARRIVE: "Enter a valid arrival airport.",
  RouteStationsFormFields__ERROR_VALID_DEPART: "Enter a valid departure airport.",
  RouteStationsFormFields__NO_MATCH_FOUND_TEXT: "No match found",
  RouteStationsFormFields__SWITCHEROO_ARIA_LABEL:
    "Click to reverse the departure and arrival airports",
};
